import React from 'react';
import { connect } from 'react-redux';

import HeaderProperties from './PropertiesComponent/HeaderProperties';
import RemoveProperty from './PropertiesComponent/RemoveProperty';
import QuestionAnswer from './PropertiesComponent/QuestionAnswer';

function PropertyFactory(item) {
  switch (item.type) {
    case 'question':
    case 'first_name':
    case 'last_name':
    case 'date_of_birth':
    case 'gender':
    case 'height':
    case 'weight':
    case 'race':
    case 'ethnicity':
    case 'preferred_language':
    case 'allergies':
    case 'medications':
      return <>
        <QuestionAnswer item={item} />
        <RemoveProperty item={item} />
      </>;
    case 'header':
      return <HeaderProperties item={item} />;
    default:
      return <RemoveProperty item={item} />;
  }
}

function DocumentProperties({ editQuestion }) {
  return <>
    <div className="col mb-2">
      <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>Properties</h5>
    </div>

    <div className="col">
      {editQuestion &&
        <div key={editQuestion.position}>{PropertyFactory(editQuestion)}</div>
      }
    </div>
  </>
}

const mapStateToProps = (state) => {
  if (state.documentBuilder.editQuestion === false) {
    return { editQuestion: false }
  }

  const editQuestion = state.documentBuilder.current.item.find((item) => {
    return item.position === state.documentBuilder.editQuestion;
  })

  return { editQuestion }
}

export default connect(mapStateToProps)(DocumentProperties);